export const DEPOSIT_CONTENT_DEFAULT_HEIGHT_RATIO = 0.62;
export const DEPOSIT_CONTENT_MIN_HEIGHT = 240;
export const DEPOSIT_CONTENT_MAX_HEIGHT_RATIO = 0.82;

/**
 * Parses the height reported by the deposit page, which can arrive as a raw number, a numeric
 * string, or a JSON string/object carrying a `height` property. Returns `undefined` (or `0`, which
 * callers should treat as falsy) when the payload doesn't carry a usable height.
 */
export const parseDepositHeightPayload = (payload: unknown): number | undefined => {
  if (typeof payload === "number" && Number.isFinite(payload)) {
    return payload;
  }

  if (typeof payload === "string") {
    const numericPayload = Number(payload);

    if (!Number.isNaN(numericPayload) && Number.isFinite(numericPayload)) {
      return numericPayload;
    }

    try {
      const parsedData = JSON.parse(payload);
      const payloadHeight = parsedData?.height;

      return typeof payloadHeight === "number" && Number.isFinite(payloadHeight) ? payloadHeight : undefined;
    } catch {
      return undefined;
    }
  }

  if (payload && typeof payload === "object") {
    const payloadHeight = (payload as { height?: unknown }).height;

    return typeof payloadHeight === "number" && Number.isFinite(payloadHeight) ? payloadHeight : undefined;
  }

  return undefined;
};

export const getBoundedDepositContentHeight = (height: number, maxHeight: number): number =>
  Math.min(Math.max(Math.round(height), DEPOSIT_CONTENT_MIN_HEIGHT), maxHeight);
